import React from 'react';
import PageBanner from '../layout/PageBanner';
import Accordion from '../ui/Accordion';
import { qaItems } from '../../data/qa';

const QAPage = () => {
  return (
    <div>
      <PageBanner
        title="Q & A"
        breadcrumbs={[{ label: 'Q & A' }]}
      />

      <section className="py-16 px-6">
        <div className="max-w-3xl mx-auto">
          <Accordion items={qaItems} />
        </div>
      </section>
    </div>
  );
};

export default QAPage;
